import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { HexLogo } from "../components/HexLogo";

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Página no encontrada — Campus EMJC</title>
      </Helmet>
      <section className="container-emjc flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
        <HexLogo variant="surprised" size={120} className="text-brand-orange" />
        <h1 className="mt-6 font-display text-6xl font-bold">404</h1>
        <p className="mt-3 max-w-md text-lg text-gray-700">
          No encontramos la página que buscabas. Probablemente fue parte de la web antigua y se ha
          movido a un sitio mejor.
        </p>
        <Link to="/" className="btn-primary mt-8">
          Volver al inicio
        </Link>
      </section>
    </>
  );
}
